import React from 'react'
import { Modal, Button } from 'antd'
import styled from 'styled-components'
import success from '../../../asserts/images/success.png'

const StyledModal = styled(Modal)`
  text-align: center;
  font-family: Gilroy;
  .title {
    font-size: 36px;
    font-weight: 600;
  }

  .created-success-msg {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.3px;
    margin-top: 34px;
    margin-bottom: 32px;
  }

  .ant-modal-content .ant-modal-footer {
    padding: 0;
    padding-bottom: 30px;
  }

  .ant-modal-body {
    button {
      width: 300px;
      height: 48px;
      margin-top: 12px;
    }
  }
`

const CreatedClientModal = (props) => {
  const { send, skip } = props

  return (
    <StyledModal open={true} onCancel={skip} width={484} footer={<></>}>
      <h1 className="title">Success</h1>
      <img src={success} alt="success" />
      <div className="created-success-msg">Client has been created</div>
      <Button type="primary" onClick={send}>
        SEND WELCOME EMAIL
      </Button>
      <Button type="primary" ghost onClick={skip}>
        SKIP
      </Button>
    </StyledModal>
  )
}

export default CreatedClientModal
